import React, {useCallback} from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import FieldSelectEntityField from "../../select-entity-field";
import convertFieldsStructureToConfig, {
    FieldSelectorConfig
} from "../../../../../../gd-modules/common/add-column-new/convert-fields-structure"
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const"
import {PopoverMenuItemType} from "../../../../../../gd-components/popover-menu/popover-menu/const"
import {EntityType, EntityTypeDict} from "../../../../../../gd/const/item"
import PopoverAddColumn from "../../../../../../gd-modules/common/add-column-new/popover/popover"
import PopoverMenuOptionWithCustomPopover
    from "../../../../../../gd-components/popover-menu/popover-menu/option-with-custom-popover/menu-option-with-custom-popover"
import FieldsCollection from "../../../../../collection/base/fields-collection"
import FieldProto from "../../../../../proto/field-proto";

type Props = {
    field           : FieldSelectEntityField
    model           : any
    parent          : any

    options         : any // field config oiptions

    offset?         : string

    onClickOutside  : func
    onSelect        : {(fieldId:ID | null, params?: any, selectedField?: FieldProto): void}
}

// const debug = "FieldSelectEntityField_MultipleEntitiesPopover"
const debug = false

export default function FieldSelectEntityField_MultipleEntitiesPopover(props:Props) {

    const value: any = props.field.getViewValue(props.model)
    const selectedFieldIds = props.field.fieldParams.selectedFieldIds ? props.field.fieldParams.selectedFieldIds : [value]

    debug && console.log(debug, 'render', selectedFieldIds, value, props.field)

    const options: any[] = []

    _.map(props.field.fieldsCollections, (fieldsCollection: FieldsCollection) => {
        const entityType: EntityType = fieldsCollection.entityType

        options.push({
            type            : PopoverMenuItemType.CUSTOM_POPOVER,
            label           : EntityTypeDict[entityType as keyof { }],
            popoverClass    : "gd-popover-add-column-new",
            menuComponent   : (menuComponentProps: {
                menuParams  : any
                hidePopover : func
            })=> {
                const config: FieldSelectorConfig = convertFieldsStructureToConfig(props.field.fieldsStructures[entityType as keyof {}])
                return <PopoverAddColumn config                 = {config}
                                         fields                 = {fieldsCollection.models}
                                         selectedFieldIds       = {selectedFieldIds}
                                         columns                = {[{fieldId: value}]}
                                         mandatoryColumnsIds    = {[]}
                                         noValueOption          = {props.field.noValueOption ? {icon: props.field.noValueOptionIcon, label: props.field.noValueOptionLabel} : undefined}
                                         isAddVisible           = {false}
                                         hideEmptyCustomFields  = {true}
                                         hidePopover            = {menuComponentProps.hidePopover}
                                         onToggleColumn         = {props.onSelect}
                                         onNewCustomField       = {()=>{}}
                />
            },
        })
    })

    const classes = Classes(props.field.fieldParams.popoverClassName)

    const popoverPosition = new PopoverPosition({
        attachment      : props.options?.attachment,
        targetAttachment: props.options?.targetAttachment,
        offset          : props.offset,
        attachmentType  : PopoverAttachmentType.HORIZONTAL,
    })

    return (
        <Popover popoverClass     = {classes}
                 position           = {popoverPosition}
                 onClickOutside     = {props.onClickOutside}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}>
            <div className="ui5-popover-menu">
                {_.map(options, (option, key) => {
                    const menuParams = {
                        hidePopover : props.parent.hidePopover
                    }

                    return <PopoverMenuOptionWithCustomPopover key          = {key}
                                                               option       = {option}
                                                               disabled     = {option.disabled}
                                                               menuParams   = {menuParams}/>
                })}
            </div>
        </Popover>
    )
}
